import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function UrgencyBanner() {
  const spotsTaken = 75;
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 53,
    s: 58
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
        return {
          h: Math.floor(seconds / 3600),
          m: Math.floor(seconds % 3600 / 60),
          s: seconds % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  const time = `${format(timeLeft.h)}:${format(timeLeft.m)}:${format(timeLeft.s)}`;
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/40 bg-brand-blueDeep text-brand-cream shadow-md" data-id="element-307" data-mp="1bw6phrlitqwd">
      <div className="mx-auto max-w-7xl px-3 py-2.5 md:px-6" data-id="element-308" data-mp="1gurmzj9e1wh4">
        <div className="hidden items-center justify-center gap-5 text-sm font-medium md:flex" data-id="element-309" data-mp="27ezsbkxilvw5">
          <div className="flex items-center gap-2 text-brand-goldLight" data-id="element-310" data-mp="22nhtp3iys7ec">
            <ClockIcon className="h-4 w-4" data-id="element-311" data-mp="1xowpkt0ld3km" />
            <span data-id="element-312" data-mp="1xpy9zo3hz2f0">PRECIO DE LANZAMIENTO CIERRA EN:</span>
            <span className="rounded bg-white/15 px-2 py-0.5 font-mono font-bold tabular-nums text-white" data-id="element-313" data-mp="1sptxsa9mgtul">{time}</span>
          </div>
          <span className="h-4 w-px bg-white/25" data-id="element-314" data-mp="2qcj3au3j9ol7" />
          <span data-id="element-315" data-mp="2qb7z4t66eetk">
            <strong className="text-brand-amber" data-id="element-316" data-mp="2ler19796cm3a">{spotsTaken}%</strong> de cupos tomados
          </span>
          <a href="#comprar" className="rounded-full bg-brand-amber px-3 py-1 text-xs font-bold text-brand-blueDeep transition-colors duration-150 ease-out hover:bg-brand-goldLight" data-id="element-317" data-mp="2gf4qr5kqdjy6">
            VER EL KIT →
          </a>
        </div>
        <div className="relative overflow-hidden md:hidden" data-id="element-318" data-mp="14y4zmda4db5q">
          <motion.div className="flex w-max items-center gap-5 whitespace-nowrap text-[11px] font-semibold" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 16,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-319" data-mp="10xusuyei6gpt">
            {[0, 1].map(item => <React.Fragment key={item} data-id="element-320" data-mp="sglry0kldvqu">
                <span data-id="element-321" data-mp="sjq2dfonhnpy">
                  ⏰ Cierra en <strong data-id="element-322" data-mp="xg71t61avoic">{time}</strong>
                </span>
                <span data-id="element-323" data-mp="xit8l3gd9zzi">•</span>
                <span data-id="element-324" data-mp="jplen54tcsen">
                  <strong className="text-brand-amber" data-id="element-325" data-mp="joadze6o00rr">{spotsTaken}%</strong> de cupos tomados
                </span>
                <a href="#comprar" className="rounded-full bg-brand-amber px-2.5 py-1 text-brand-blueDeep" data-id="element-326" data-mp="ohlbupti177j">
                  VER EL KIT →
                </a>
              </React.Fragment>)}
          </motion.div>
        </div>
      </div>
    </div>;
}